import { QueryClient } from '@tanstack/react-query';

// Ids of the certificate tasks whose answer is currently in flight. The key is intentionally NOT a
// prefix of ['certificate/tasks'] so that invalidating the tasks list never touches it.
export const ANSWERING_CERTIFICATE_TASKS_QUERY_KEY = ['certificate-tasks-answering'];

export const addAnsweringCertificateTask = (queryClient: QueryClient, taskId: number): void => {
  queryClient.setQueryData<number[]>(ANSWERING_CERTIFICATE_TASKS_QUERY_KEY, (prev) => {
    return Array.from(new Set([...(prev ?? []), taskId]));
  });
};

export const removeAnsweringCertificateTask = (queryClient: QueryClient, taskId: number): void => {
  queryClient.setQueryData<number[]>(ANSWERING_CERTIFICATE_TASKS_QUERY_KEY, (prev) => {
    return (prev ?? []).filter((id) => {
      return id !== taskId;
    });
  });
};
